import { createFileRoute } from '@tanstack/react-router';

import { RequireAccess } from '@/features/auth/RequireAccess';
import { BoardYearShell } from '@/features/dashboard/BoardYearShell';
import { DeaneryBoard } from '@/features/dashboard/DeaneryBoard';

export const Route = createFileRoute('/_app/dekanat/$name')({
  component: DeaneryRoute,
});

// Profil dekanatu oglądany z konta diecezji (linki z tabeli „Moje dekanaty").
// Bramka UX, nie autoryzacja — backend i tak scope'uje listy po tokenie.
function DeaneryRoute() {
  return (
    <RequireAccess allow={(session) => session.scope.kind === 'diocese'}>
      <DeaneryContent />
    </RequireAccess>
  );
}

function DeaneryContent() {
  const { name } = Route.useParams();
  return (
    <BoardYearShell crumb={name}>
      {(year) => <DeaneryBoard name={name} year={year} />}
    </BoardYearShell>
  );
}
